import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import cn from 'classnames';

import Message from '../Message/Message';
import styles from './MessagesList.module.css';

const MessagesList = ({
  className,
  messages,
  setDelay,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
}) => {
  return (
    <div className={cn(styles.wrapper, className)}>
      <TransitionGroup className={styles.messages}>
        {messages.length > 0 &&
          messages.map((item, i) => (
            <CSSTransition key={item.UUID} timeout={1500} classNames="position">
              <Message
                key={item.id}
                message={item.message}
                titrTag={item.titrTag}
                setDelay={setDelay}
                currentMessageRef={currentMessageRef}
                authorFontSize={authorFontSize}
                msgFontSize={msgFontSize}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
    </div>
  );
};
export default React.memo(MessagesList);
